"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NotificationBanner = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireWildcard3(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _customComponents = require("../../../../utils/customComponents");

var _customProps = require("../../../../utils/customProps");

var _Storyblok = _interopRequireDefault(require("../../../../utils/Storyblok"));

/* istanbul ignore next */
var Typography = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/molecules/Typography/Typography"));
  });
});
/* istanbul ignore next */

var ButtonRedirect = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/molecules/ButtonRedirect/ButtonRedirect"));
  });
});
/* istanbul ignore next */

var IconButtonRedirect = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/molecules/IconButtonRedirect/IconButtonRedirect"));
  });
});
/* istanbul ignore next */

var Icon = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/atoms/Icon/Icon"));
  });
});
var components = {
  Typography: Typography,
  ButtonRedirect: ButtonRedirect,
  IconButtonRedirect: IconButtonRedirect,
  Icon: Icon
};

var NotificationBanner = function NotificationBanner(_ref) {
  var rootClass = _ref.rootClass,
      color = _ref.color,
      content = _ref.content,
      top = _ref.top,
      dataBlokC = _ref.dataBlokC,
      dataBlokUid = _ref.dataBlokUid,
      storyblokClass = _ref.storyblokClass;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass, {
    top: top
  });

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showBanner = _useState2[0],
      setBanner = _useState2[1];

  var handleClose = function handleClose() {
    setBanner(false);
  };

  return showBanner ? /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    color: color,
    position: "fixed",
    className: "".concat(styles.root, " ").concat(storyblokClass),
    "data-blok-c": dataBlokC,
    "data-blok-uid": dataBlokUid
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'relative'
    }
  }, content.map(function (component, key) {
    return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
      fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
    }, (0, _customComponents.renderComponentsWithBridge)(components, component, key));
  }), /*#__PURE__*/_react.default.createElement(_core.Icon, {
    onClick: handleClose,
    style: {
      cursor: 'pointer',
      color: 'red',
      position: 'absolute',
      top: '15px',
      right: '15px'
    }
  }, "clear"))) : null;
};

exports.NotificationBanner = NotificationBanner;
var _default = NotificationBanner;
exports.default = _default;
NotificationBanner.propTypes = {
  /**
   * storyblok multiselect of css classes
   * Override or extend the styles applied to the component.
  */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * mui props: 'default' | 'inherit' | 'primary' | 'secondary' | 'transparent'
   * AppBar: The color of the component.
   * It supports those theme colors that make sense for this component.
   * */
  color: function color(props, propName, componentName) {
    var validProps = ['default', 'inherit', 'primary', 'secondary', 'transparent'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * Positioning of the banner from the top of the page.
   * */
  top: _propTypes.default.string,

  /**
   * Components: MuiTypography
   */
  content: function content(props, propName, componentName) {
    var comps = ['Typography'];
    return (0, _customProps.validComponents)(props, propName, componentName, comps);
  },

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokC: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokUid: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  storyblokClass: _propTypes.default.string
};
NotificationBanner.defaultProps = {
  color: 'primary',
  rootClass: [],
  content: [],
  top: '60px',
  dataBlokC: '',
  dataBlokUid: '',
  storyblokClass: ''
};